import {React, useEffect} from "react";
import {Helmet} from "react-helmet";
import HeroHeader from "./HeroHeader";
import ContactCTA from "./ContactCTA";
import ButtonLink from "./ButtonLink";

import CPRlayout from "../img/CPR_layout2.png";
import CPRchart1 from "../img/CPR_Chart1.svg";
import CPRchart2 from "../img/CPR_Chart2.svg";
import CPRchart3 from "../img/CPR_Chart3.svg";
import CPRchart4 from "../img/CPR_Chart4.svg";

import CPRdemo1 from "../img/CPR_clip1.gif";
import CPRdemo2 from "../img/CPR_clip2.gif";
import CPRdemo3 from "../img/CPR_clip3.gif";

import BLSchart from "../img/BLS_flowchart.jpeg";


import CPReffort from "../img/CPR_EffortImpact.png";
import CPR_WIP from "../img/CPR_WIP.PNG";
import CPR_early from "../img/CPR_early.gif";

import CPRpalette from "../img/CPR_palette.PNG";



function CPRassist() {

  // useEffect(() => {
  //   document.title = "ETCHNG | Assisting CPR rescuers with guided steps and simulated scenarios";  
  
  // }, []);    
  
  return (
    <>
<Helmet>
        <title>ETCHNG | Assisting CPR rescuers with guided steps and simulated scenarios</title>
        <meta name="description" content="CPR simulation mobile app"/> 
        <meta name="keywords" content="ETCHNG, medical illustrator, Eric Chung, CPR, mobile app, Unity, 3D, animation, UI/UX"
        />
    </Helmet>

      <HeroHeader
        hero_img={CPRlayout}
        type="Mobile app —"
        name="Assisting CPR rescuers with guided steps and simulated scenarios"
      />

      <div className="wrapper">
        <div className="wrapper__inner">
          <div className="work">
            <div className="work__info twoColumn">
              <div className="work__info__basic">
              <div className='work__info__basic__item'><h5>Date</h5>
                <p>Nov 2021 - Feb 2022</p></div>
                <div className='work__info__basic__item'><h5>Roles</h5>
                <p>UI/UX designer, Unity developer</p></div>
                <div className='work__info__basic__item'><h5>Tools</h5>
                <p>Unity, Figma, Blender</p></div>
              </div>
            </div>

            <div className="work__info twoColumn">
              <h4>INTRODUCTION</h4>
              <p>
                Cardiac arrest (CA) is the leading mortality factor in North
                America, annually resulting in over 155,000 and 18,000
                out-of-hospital CA events in the United States and Canada,
                respectively. Without oxygenated blood circulating the body and
                reaching the brain, CA is deadly if not treated within minutes,
                and the survival rate for out-of-hospital CA typically sits
                below 5%.
              </p>

              <div className="btn__wrap">
                <a href="https://etchng.github.io/CPR-demo/" target="_blank">
                  <ButtonLink> View Demo</ButtonLink>
                </a>
              </div>
            </div>

            
          </div>
          <div className="work">
              <div className="work__info twoColumn">
                <h4>CHALLENGE</h4>
              </div>
              <div className="work__info twoColumn">
                <p>
                  Bystanders are a potentially valuable asset in timely
                  administration of CPR, and bystander CPR is known to quadruple
                  out-of-hopistal survival rate. Despite this, engagement rate
                  of bystanders in CPR has remained consistently low, typically
                  hovering below 15%.
                </p>
              </div>
            </div>

        

            <div className="work">
              <div className="work__info twoColumn">                <h4>RESEARCH</h4>

                <p>
                  In addition to conducting secondary research in emergency
                  medicine journals, which confirmed the importance of timely
                  CPR and the role of bystanders, I also conducted
                  questionnaires and interviews, both with users who had never
                  learned CPR, as well with those who had previously learned it.
                  This was to better understand their perceptions of CPR, and
                  reasons for hesistation in an emergency.
                  <br />
                  <br />
                  This uncovered the following:
                  {/* <br />
                  <br />
                  <br /> */}
                </p>
              </div>
              <div className="work__info twoColumn">
                <ol>
                  <li>
                    <b>Reluctance in learning CPR</b>
                    <p>
                      Of the users who had ever learned CPR (55.6%), only 40% of
                      them currently knew how to perform it. The primary factors
                      behind this were the time commitment required, and the
                      expectation that it was unlikely to be needed. However,
                      they also indicated that they would be interested in
                      learning should a convenient opportunity arise.
                    </p>
                  </li>
                  <li>
                    <b>Hesistation of harming</b>
                    <p>
                      Regardless of already having CPR training, users uniformly
                      indicated that they would be hesitant to perform CPR in an
                      emergency. This was largely attributed to lack of regular
                      practice, and fear of making a mistake (along with the
                      potential legal liability). They were also concerned about
                      the potential for disease transmission during rescue
                      breathing.
                    </p>
                  </li>

                  <li>
                    <b>Complexity of steps</b>
                    <p>
                      Users who had previously learned CPR indicated the the
                      logic and complexity of the steps to be challenging. In
                      particular, they struggled with differences in different
                      types of individuals (adults, children, etc.), appropriate
                      landmarking and measurements, and the branching
                      decision-making.
                    </p>
                  </li>
                </ol>
              </div>
            </div>
            <div className="work">
              <div className="work__info twoColumn">
                <img src={CPRchart1}></img>
              </div>
              <div className="work__info twoColumn">
                <img src={CPRchart2}></img>
              </div>
            </div>
            <div className="work">
              <div className="work__info twoColumn">
                <img src={CPRchart3}></img>
              </div>
              <div className="work__info twoColumn">
                <img src={CPRchart4}></img>
              </div>
            </div>
            
            <div className="work">
              <div className="work__info twoColumn">
                <h4>IDEATION</h4>
                <br />
                <p>
                  In conjunction with doing a gap analysis of existing
                  CPR-related mobile applications, primary and secondary
                  research was then translated into three high-level user needs:
                </p>
                <img
                  src={BLSchart}
                  loading="lazy"
                  alt="Basic life support algorithm flowchart"
                ></img>
                <p>
                  This is what a BLS flowchart resembles; user research
                  indicated that in the context of an emergency, this would be
                  difficult to understand for a novice because of panicked
                  tunnel vision.
                </p>
              </div>
              <div className="work__info twoColumn">
                <ol>
                  <li>
                    <b>Simplified guided flow for assistance</b>
                    <p>
                      The typical methods of showing CPR instructions typically
                      involve several text-dense steps with occasional visual
                      elements, or involve a (basic life support/BLS)
                      flow-chart. While the latter is briefer and more visual,
                      it is remains overwhelming and is intended for an
                      experienced individual. A scaffolded approach is thus
                      required.
                    </p>
                  </li>
                  <li>
                    <b>Engaging practice scenarios</b>
                    <p>
                      While a handful of existing CPR training apps include some
                      variation of a practice mode to facilitate public
                      engagement, they focus on the compression component
                      specifically, without addressing the decision-making flow.
                      Similar to the previous point, it is important scaffold
                      knowledge-building using a lower-fidelity design and not
                      introduce too much noise through visual complexity.
                    </p>
                  </li>
                  <li>
                    <b>Information transparency</b>
                    <p>
                      A significant barrier to CPR rescuer involvement were
                      concerns about their own protection, both in terms of
                      liability, as well as personal safety; current
                      expectations and standards are typically not disclosed in
                      most media.
                    </p>
                  </li>
                </ol>
              </div>
            </div>
            <div className="work">
              <div className="work__info twoColumn">
                <p>
                  Features were organized pased on potential impact and
                  feasibility. Early concepts included a VUI to facilitate a
                  more conversational, hands-free experience, leveraging device
                  sensors to help maintain candence, and AR-based training
                  scenarios.
                </p>
              </div>
              <div className="work__info">
                <img
                  src={CPReffort}
                  loading="lazy"
                  alt="Impact-effort matrix."
                ></img>
              </div>
            </div>

            
            <div className="work">
              <div className="work__info narrowColumn">
                <h4>PROTOTYPING</h4>

                <p>
                  A emergency assistant UI was prototyped in Figma, and the
                  training module is being programmed and developed in Unity.
                </p>

                <p>
                  <b>
                    The video DevLog 3 is the current iteration; 1 and 2 are
                    earlier iterations.
                  </b>
                </p>

                <div className="work__info singleColumn">
                  <iframe
                    className="youtube"
                    height="300"
                    src="https://www.youtube.com/embed/n48dVCN9aPM"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>

                  <iframe
                    className="youtube"
                    height="300"
                    src="https://www.youtube.com/embed/g-7ChDmX008"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
              <div className="work__info wideColumn">
                <img
                  src={CPR_WIP}
                  loading="lazy"
                  alt="Early wireframes."
                ></img>
                <p>
                  This has been complemented by several rounds of user feedback
                  and testing.
                </p>
                <img src={CPR_early}></img>
                <p>
                  This was an early iteration of a functional prototype that I
                  developed in Unity.
                </p>
              </div>
            </div>

            <div className="work">
              <h4>DESIGN</h4>
            </div>
            <div className="work">
              <div className="work__info twoColumn">
                <p>
                  This is the current state of the adult scenario flow. While
                  further adjustments are currently being made based on
                  feedback, overall response has been positive. On a
                  user-reported Likert scale of confidence in performing CPR,
                  there was a 3-point increase between pre and post usage, who
                  also indicated that they would interested in continued usage.
                </p>
                <iframe
                  className="youtube"
                  height="315"
                  src="https://www.youtube.com/embed/okR60-1P5d0"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
              <div className="work__info twoColumn">
                <img src={CPRdemo1}></img>
              </div>
            </div>
            <div className="work">
              <div className="work__info twoColumn">
                <p>
                  The overall visual style was specifically intended to mimic a
                  minimalist, technical illustration style for clarity.
                  Interestingly, earlier feedback from users indicated that a
                  higher-fidelity avatar design was actually jarring due to the
                  uncanny valley effect; users were more willing to help the
                  stylized avatar over a more detailed one.
                </p>{" "}
              </div>
              <div className="work__info twoColumn">
                <img src={CPRdemo3}></img>
              </div>
            </div>
            <div className="work">
              <div className="work__info twoColumn">
                <img src={CPRdemo2}></img>
              </div>
              <div className="work__info twoColumn">
                <iframe
                  className="youtube"
                  height="315"
                  src="https://www.youtube.com/embed/Eimp4oM15Pc"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
                <br /> <br />
                <p>
                  This is the flow for the emergency assistant. User feedback
                  has indicated that the narrator feature was especially
                  valuable; in an emergency situation, they would only read
                  bolded text, buttons and images -- further iterations for
                  making it less text-dense and more conversational (similar to
                  a game dialogue system) are being designed.
                </p>
              </div>
            </div>
            <div className="work singleColumn">
              <img src={CPRlayout}></img>
            </div>

            <div className="work">
              <div className="work__info narrowColumn">
                <p>
                  The colour palette was developped with accessibility in mind;
                  it supports the various types of colour-blindness. It was also
                  designed to minimize visual noise, and reinforce clear
                  delineation between the two modes.
                </p>{" "}
              </div>
              <div className="work__info wideColumn">
                <img src={CPRpalette}></img>
              </div>
            </div>
        </div>

        <ContactCTA />
      </div>
    </>
  );
}

export default CPRassist;
